import { render } from "./ModelFooter.vue?vue&type=template&id=3d9c3d97"
import script from "./ModelFooter.vue?vue&type=script&lang=js"
export * from "./ModelFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__